import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  constructor() {
    super()

    this.setWindowHeight()
    window.addEventListener('resize', () => this.setWindowHeight())
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  connectedCallback() {
    super.connectedCallback()
    const menuItems = this.querySelectorAll(
      '.header__menu-item--wrapper.has-submenu'
    )

    // Function to check if any HHDetailsModal is open
    const isModalOpen = () => !!document.querySelector('hh-details-modal[is-open]');

    menuItems.forEach((item) => {
      item.addEventListener('mouseover', (event) => {
        if (!isModalOpen()) {
          event.currentTarget.classList.add('active');
          document.body.classList.add('lock-body');
        }
      })
      item.addEventListener('mouseleave', (event) => {
        event.currentTarget.classList.remove('active')
        document.body.classList.remove('lock-body')
      })
      item.querySelector('.js-header-parent-item')?.addEventListener('click', this.toggleMenu.bind(this))
    })
  }

  toggleMenu(event) {
    event.preventDefault()
    const wrapper = event.currentTarget.closest('.has-submenu')
    if (wrapper.classList.contains('active')) {
      wrapper.classList.remove('active')
      document.body.classList.remove('lock-body')
      event.currentTarget.closest('.js-header-parent-item-button').setAttribute('aria-expanded', false)
    } else {
      wrapper.classList.add('active')
      document.body.classList.add('lock-body')
      event.currentTarget.closest('.js-header-parent-item-button').setAttribute('aria-expanded', true)
    }
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active'])
    document.dispatchEvent(new CustomEvent('miniCartToggled'))
  }

  setWindowHeight() {
    document
      .querySelector('html')
      .style.setProperty('--hh-window-height', `${window.innerHeight}px`)

    document.documentElement.style.setProperty(
      '--hh-header-height',
      `${this.offsetHeight}px`
    )

    const searchBar = document.querySelector('.js-search-bar')
    if (searchBar)
      document.documentElement.style.setProperty(
        '--hh-search-height',
        `${searchBar.offsetHeight}px`
      )
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
